import React from "react";
import { RocketButton } from "../../assets";
import { Button } from "../button/button";
import { useHistory } from "react-router-dom";
import "./quizCompleteModal.css";

const QuizCompleteModal = () => {
  const history = useHistory();
  return (
    <div className="modalContainer">
      <div className="modalMain">
        <img src={RocketButton} className="rocket" />
        <h2 className="header">Congrats!</h2>
        <p>
          Congratulations on completing the technical test. Your results would
          be sent to your mail soon.
        </p>
        <Button
          buttonName="OK"
          onClick={() => history.push("/dashboard")}
          className="modalButton"
        />
      </div>
    </div>
  );
};

export default QuizCompleteModal;
